import { type Field, useFormApi } from '@data-driven-forms/react-form-renderer';

import AccordionContainer from '~/common/components/AccordionContainer';

type AccordionProps = {
  title?: string;
  secondaryTitle?: string;
  multiple?: boolean;
  expanded?: boolean;
  accordionButtonProps?: any;
  accordionPanelProps?: any;
  accordionContainerProps?: any;
  border?: string;
  fields?: React.ReactNode[] | any[];
  layoutType?: string;
};

export default function Accordion({
  title,
  secondaryTitle,
  multiple = true,
  expanded = false,
  fields = [],
  layoutType,
  border,
  accordionButtonProps,
  accordionPanelProps,
  accordionContainerProps,
}: Readonly<AccordionProps>) {
  const { renderForm } = useFormApi();
  return (
    <AccordionContainer
      header={title}
      secondaryHeader={secondaryTitle}
      allowToggle={!expanded}
      allowMultiple={multiple}
      marginTop={accordionContainerProps?.marginTop ?? '1rem'}
      marginRight={accordionContainerProps?.marginRight}
      marginLeft={accordionContainerProps?.marginLeft}
      layoutType={layoutType}
      accordionPanelProps={accordionPanelProps}
      accordionButtonProps={accordionButtonProps}
      border={border}
    >
      {renderForm(fields as Field[])}
    </AccordionContainer>
  );
}
